<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="1600px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :append-to-body="true"
    class="main-content"
    top="5vh"
    @close="$emit('close')"
  >
    <div class="app-main-content" style="min-height: 400px">
      <partner-form ref="partnerForm" @rowChange="onRowChange" @audit="toAudit" @back="backToList" @refresh-data="refreshData" />
    </div>
  </el-dialog>
</template>

<script>
import partnerForm from '@/views/cargo/v0/Information/components/partner/partnerForm.vue'

export default {
  name: 'CompanyDialog',
  components: { partnerForm },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String, default: ''
    },
    rowData: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      loading: null
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {
    innerVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.init()
        })
      }
    }
  },
  methods: {
    onRowChange() {},
    toAudit() {},
    backToList() {},
    refreshData() {},
    async init() {
      await this.$refs.partnerForm.onShow('bpmLook', this.rowData, this.rowData[0])
    }
  }
}
</script>

<style scoped>

</style>
